// extracted by mini-css-extract-plugin
export var clickableWrapper = "_2a-2";
export var placeholderIcon = "_2a-3";
export var thumbnailCanvas = "_2a-1";
export var thumbnailWrapper = "_2a-0";